import { axiosBaseQuery } from '../utils/rtk-query';
import { createApi } from '@reduxjs/toolkit/query/react';
import { SubscriptionData } from '../../Tools/SubscriptionManagement/constants';

export interface CancelSubscriptionResponse {
  statusCode: number;
  body: AuthorizeDotNetCancelSubscriptionResponse;
}

export interface AuthorizeDotNetCancelSubscriptionResponse {
  refId: string;
  messages: {
    resultCode: string;
    message: Array<{
      code: string;
      text: string;
    }>;
  };
}

interface AuthorizeDotNetMessageMessageInfo {
  code: string;
  text: string;
}

interface AuthorizeDotNetMessage {
  resultCode: string;
  message: AuthorizeDotNetMessageMessageInfo[];
}

interface DeleteCustomerPaymentProfileResponse {
  messages: AuthorizeDotNetMessage;
}

interface CustomerPaymentProfileId {
  paymentProfileId: string;
  source?: string;
}

export const subscriptionManagementApi = createApi({
  reducerPath: 'subscriptionManagementApi',
  baseQuery: axiosBaseQuery({
    baseUrl: config.stcPaymentServiceUrl,
  }),
  tagTypes: ['SubscriptionData'],
  endpoints: (builder) => ({
    getAllSubscriptions: builder.query<SubscriptionData[], void>({
      query: () => ({
        url: '/pt/subscriptions',
        method: 'GET',
      }),
      providesTags: ['SubscriptionData'],
    }),
    cancelSubscription: builder.mutation<CancelSubscriptionResponse, { subscriptionId: string }>({
      query: (data) => ({
        url: `/pt/subscription/cancel`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['SubscriptionData'],
    }),
    deletePaymentProfile: builder.mutation<DeleteCustomerPaymentProfileResponse | string, CustomerPaymentProfileId>({
      query: (data) => ({
        url: '/profile/payment',
        method: 'DELETE',
        data,
      }),
      invalidatesTags: ['SubscriptionData'],
    }),
  }),
});

export const { useGetAllSubscriptionsQuery, useCancelSubscriptionMutation, useDeletePaymentProfileMutation } =
  subscriptionManagementApi;
